import { render, staticRenderFns } from "./TqAvatarGenerator.vue?vue&type=template&id=2b606277&scoped=true&"
import script from "./TqAvatarGenerator.vue?vue&type=script&lang=js&"
export * from "./TqAvatarGenerator.vue?vue&type=script&lang=js&"
import style0 from "./TqAvatarGenerator.vue?vue&type=style&index=0&id=2b606277&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b606277",
  null
  
)

export default component.exports